



















import Vue from 'vue';
import { mapGetters } from 'vuex';

// Firebase
import firebase from 'firebase/app';
import 'firebase/auth';

export default Vue.extend({
	name: 'BreadcrumbBar',

	props: {
		mobile: Boolean,
	},

	computed: {
		...mapGetters(['breadcrumb', 'currentUser', 'loading']),
		route() {
			return this.$route;
		},
	},

	methods: {
		async signOut() {
			console.log('signing out...');
			const user = await firebase
				.auth()
				.signOut()
				.catch(error => {
					const errorCode = error.code;
					const errorMessage = error.message;
					console.log(errorMessage);
				});
		},

		openAnotherTab() {
			window.open(this.$route.fullPath, '_blank');
		},
	},
});
